/* eslint-disable max-len */
const thTh = {
  CancellationRequest: 'คำขอยกเลิกการจอง',
  Heading: 'กรุณาระบุข้อมูลดังต่อไปนี้ กรุณาระบุข้อมูลให้ครบทุกช่อง',
  Note: 'ต้องการยกเลิกการจอง? เราพร้อมให้ความช่วยเหลืออยู่เสมอ กรุณากรอกข้อมูลในช่องด้านล่างเพื่อขอยกเลิกการจองที่คุณต้องการ',
  PartnerNote:
    'ขอบคุณค่ะ! เราดำเนินการคำขอยกเลิกตามลำดับวันเข้าพักที่ใกล้ก่อน หากคุณไม่ได้รับการยืนยันการยกเลิกการจองจากเราก่อนวันเข้าพัก โปรดทราบว่าการยกเลิกนั้นกำลังอยู่ในขั้นตอนการยกเลิก โดยคุณไม่จำเป็นต้องทำการใดๆ',
  SubmitNote:
    'เนื่องจากมีการเดินทางที่ได้รับผลกระทบจำนวนมาก กระบวนการคืนเงินจึงอาจเกิดความล่าช้า ขออภัยในความไม่สะดวกมา ณ ที่นี้',
  Disclaimer:
    'หมายเหตุสำคัญ: แบบฟอร์มนี้สำหรับวันเข้าพักถึงวันที่ 31 ธันวาคม 2021 เท่านั้น',
  Itin: 'หมายเลขแผนการเดินทาง (หมายเลขและตัวอักษร 11-15 ตัวในแผนการเดินทางหรืออีเมลยืนยันการจอง)',
  EmailAddress: 'อีเมลที่ใช้ในการจอง',
  PhoneNumber: 'หมายเลขโทรศัพท์ที่ใช้ในการจอง',
  Reason: 'สาเหตุ',
  Submit: 'ดำเนินการต่อ',
  Success: 'เราได้รับคำขอของคุณแล้ว',
  Failed: 'ขออภัย',
  InProgress: 'เราอยู่ระหว่างดำเนินการ',
  TryAgain: 'ย้อนกลับ',
  PhoneErrorMessage: 'กรุณาป้อนหมายเลขโทรศัพท์ที่ถูกต้อง',
  EmailErrorMessage: 'กรุณากรอกอีเมลที่ถูกต้อง',
  ItinErrorMessage: 'โปรดป้อนหมายเลขแผนการเดินทางที่ถูกต้อง',
  ResponseEligibleHeader: 'เราพบแผนการเดินทางของคุณแล้ว',
  ResponseEligibleSubmit: 'ใช่ ยกเลิกการจองนี้เลย',
  ResponseEligibleNeverMind: 'ไม่ยกเลิก',
  ResponseOnlyLodgingWithRefund:
    'คุณมีการจองที่พัก {x} รายการที่สามารถขอรับเงินคืนได้ หากคุณยกเลิกการจองเหล่านี้ คุณจะได้รับเงินคืนเต็มจำนวนกลับไปยังวิธีการชำระเงินที่คุณใช้จอง',
  ResponseOnlyLodgingWithCoupon:
    'คุณมีการจองที่พัก {x} รายการที่สามารถขอรับเงินคืนในรูปแบบของคูปอง หากคุณเลือกยกเลิก คุณจะได้รับคูปองตามมูลค่าการจองเดิม',
  ResponseOnlyLodgingInEligible:
    'คุณมีการจองที่พัก {x} รายการที่ไม่สามารถยกเลิกการจองได้ฟรี หากคุณเลือกยกเลิก การยกเลิกจะเป็นไปตามนโยบายการยกเลิกตามปกติของที่พัก',
  ResponseLodgingWithOtherLob:
    'การจองอื่นๆ ทั้งหมดที่อยู่ในแผนการเดินทางนี้จะเป็นไปตามนโยบายของพาร์ทเนอร์การเดินทาง',
  ResponseNoLodgingWithOtherLob:
    'การจองทั้งหมดที่อยู่ในแผนการเดินทางนี้จะเป็นไปตามนโยบายของพาร์ทเนอร์การเดินทาง',
  ResponseAlreadyCancelled:
    'คุณมีการจองที่พักที่ยกเลิกไปแล้ว {x} รายการ เนื่องจากมีการเดินทางที่ได้รับผลกระทบจำนวนมาก กระบวนการคืนเงินจึงอาจเกิดความล่าช้า หากคุณมีคำถามหรือข้อสงสัย กรุณาโทรติดต่อฝ่ายบริการลูกค้า',
  ResponseNoFlexAvailable:
    'คุณมีการจองที่พัก {x} รายการที่ไม่เข้าเกณฑ์ขอรับเงินคืนในรูปแบบของคูปอง หากคุณยกเลิกในตอนนี้ การยกเลิกจะเป็นไปตามนโยบายการยกเลิกตามปกติของที่พัก อย่างไรก็ตาม นโยบายการยกเลิกอาจมีการเปลี่ยนแปลง กรุณากลับมาตรวจสอบข้อมูลอีกครั้ง 8 วันก่อนเดินทางเพื่อดูนโยบายการยกเลิกล่าสุด',
  ResponseInvalidDuplicateItinerary:
    'คุณได้ส่งคำขอนี้เข้ามาเรียบร้อยแล้ว เราดำเนินการคำขอยกเลิกตามลำดับวันเข้าพักที่ใกล้ก่อน หากคุณไม่ได้รับการยืนยันการยกเลิกการจองจากเราก่อนวันเข้าพัก โปรดทราบว่าการยกเลิกนั้นกำลังอยู่ในขั้นตอนการยกเลิก โดยคุณไม่จำเป็นต้องทำการใดๆ',
  ResponseElligibleConfirmation: 'คุณต้องการยกเลิกการจองนี้?',
  ResponseInvalidUnknown:
    'เราไม่พบหมายเลขแผนการเดินทางหรือหมายเลขยืนยันที่คุณระบุ โปรดตรวจสอบความถูกต้องและลองอีกครั้ง คุณสามารถค้นหาหมายเลขดังกล่าวได้จากอีเมลที่ได้รับเมื่อจองกับเรา',
  ResponseInvalidItineraryNotFound:
    'เราไม่พบหมายเลขแผนการเดินทางหรือหมายเลขยืนยันที่คุณระบุ โปรดตรวจสอบความถูกต้องและลองอีกครั้ง คุณสามารถค้นหาหมายเลขดังกล่าวได้จากอีเมลที่ได้รับเมื่อจองกับเรา',
  ResponseInvalidTripMoreThanSevenDays: 'เราไม่สามารถดำเนินการตามคำขอของคุณได้',
  ResponseInvalidTripIsLcc:
    'สายการบินที่คุณจองเป็นผู้รับผิดชอบการยกเลิกการจองทั้งหมด โปรดติดต่อสายการบินโดยตรง กรุณาเข้าสู่ระบบบัญชีและตรวจสอบแผนการเดินทางแบบออนไลน์ของคุณสำหรับข้อมูลเพิ่มเติม การจองที่อยู่ระหว่างดำเนินการยกเลิกจะขึ้นสถานะว่า ยกเลิกแล้ว ในแผนการเดินทางของคุณภายใน 72 ชั่วโมง',
  ResponseInvalidTripIsTicketless:
    'สายการบินที่คุณจองเป็นผู้รับผิดชอบการยกเลิกการจองทั้งหมด โปรดติดต่อสายการบินโดยตรง กรุณาเข้าสู่ระบบบัญชีและตรวจสอบแผนการเดินทางแบบออนไลน์ของคุณสำหรับข้อมูลเพิ่มเติม การจองที่อยู่ระหว่างดำเนินการยกเลิกจะขึ้นสถานะว่า ยกเลิกแล้ว ในแผนการเดินทางของคุณภายใน 72 ชั่วโมง',
  ResponseInvalidItinerary: 'หมายเลขแผนการเดินทางนี้ไม่ถูกต้อง โปรดลองอีกครั้ง',
  ResponseInvalidStatus: 'เกิดข้อผิดพลาดบางประการ โปรดลองอีกครั้ง',
  ResponseInvalidEmail:
    'เราไม่พบอีเมลที่คุณระบุ หรืออาจไม่ใช่อีเมลเดียวกับที่ปรากฏในแผนการเดินทางที่คุณระบุ กรุณาตรวจสอบอีกครั้งว่าเป็นอีเมลเดียวกับที่ใช้ในการจอง',
  ResponseInvalidPhone:
    'หมายเลขโทรศัพท์ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้งว่าเป็นหมายเลขโทรศัพท์เดียวกับที่ใช้ในการจอง',
  ResponseTripHasLccFlight:
    'เราสามารถยกเลิกการจองของคุณบางรายการได้ แต่ไม่สามารถยกเลิกได้ทั้งหมด กรุณาติดต่อผู้ให้บริการด้วยตนเองอีกครั้งสำหรับรายการที่เราไม่สามารถยกเลิกได้ คุณสามารถดูที่แผนการเดินทางแบบออนไลน์ของคุณเพื่อระบุการจองที่ต้องการยกเลิก การจองที่อยู่ระหว่างดำเนินการยกเลิกจะขึ้นสถานะว่า ยกเลิกแล้ว ในแผนการเดินทางของคุณภายใน 72 ชั่วโมง',
  ResponseErrorTripWithin24Hrs:
    'เราไม่สามารถดำเนินการยกเลิกให้คุณได้เนื่องจากเหลือเวลาน้อยกว่า 24 ชั่วโมงก่อนถึงกำหนดเดินทาง กรุณาเข้าสู่ระบบบัญชีและตรวจสอบแผนการเดินทางแบบออนไลน์ของคุณสำหรับข้อมูลเพิ่มเติม',
  ResponseInvalidTripInCruise:
    'ทริปเรือสำราญไม่สามารถใช้แบบฟอร์มนี้เพื่อส่งคำขอยกเลิกได้ กรุณาเข้าสู่ระบบบัญชีและยกเลิกการจองทางออนไลน์จากแผนการเดินทางของคุณ',
};

export default thTh;
